import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import SellerProfiles from './SellerProfiles';
import CustomerProfiles from './CustomerProfiles';
import BankAccounts from './BankAccounts';
import ItemProfiles from './ItemProfiles';
import NoteTemplates from './NoteTemplates';
import BillSettings from './BillSettings';

const TABS = [
  { key: 'seller-profiles',   label: '🏢  Seller Profiles' },
  { key: 'customer-profiles', label: '👥  Customer Profiles' },
  { key: 'bank-accounts',     label: '🏦  Bank Accounts' },
  { key: 'item-profiles',     label: '📦  Item Profiles' },
  { key: 'note-templates',    label: '📝  Note Templates' },
  { key: 'bill-settings',     label: '🔢  Bill Number' },
];

const VALID_TABS = TABS.map((t) => t.key);

const InvoiceSettings = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState(
    VALID_TABS.includes(tabParam) ? tabParam : 'seller-profiles'
  );

  const handleTabChange = (key) => {
    setActiveTab(key);
    setSearchParams({ tab: key });
  };

  return (
    <div>
      <div style={{
        display: 'flex',
        gap: 4,
        borderBottom: '2px solid #e5e7eb',
        padding: '0 2rem',
        background: '#fff',
      }}>
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => handleTabChange(tab.key)}
            style={{
              padding: '0.75rem 1.25rem',
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              fontSize: 14,
              fontWeight: activeTab === tab.key ? 700 : 500,
              color: activeTab === tab.key ? '#630137' : '#6b7280',
              borderBottom: activeTab === tab.key ? '2px solid #630137' : '2px solid transparent',
              marginBottom: -2,
              transition: 'color 0.15s',
              whiteSpace: 'nowrap',
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div>
        {activeTab === 'seller-profiles'   && <SellerProfiles />}
        {activeTab === 'customer-profiles' && <CustomerProfiles />}
        {activeTab === 'bank-accounts'     && <BankAccounts />}
        {activeTab === 'item-profiles'     && <ItemProfiles />}
        {activeTab === 'note-templates'    && <NoteTemplates />}
        {activeTab === 'bill-settings'     && <BillSettings />}
      </div>
    </div>
  );
};

export default InvoiceSettings;
